import { CheckCircle2, ChevronRight } from "@tamagui/lucide-icons";
import { useMemo } from "react";
import { Text, XStack, YStack } from "tamagui";
import { Body } from "../../../ui/Body";
import { Box, type BoxProps } from "../../../ui/Box";
import type { IconProp } from "../../../ui/icons";
import { Label } from "../../../ui/Label";

export const Selection: React.FC<
  {
    onSelect: () => void;
    title: string;
    description: string;
    icon: IconProp | string;
    selected?: boolean;
    showChevron?: boolean;
  } & BoxProps
> = ({
  onSelect,
  title,
  description,
  icon,
  selected,
  showChevron = true,
  ...boxProps
}) => {
  const Icon = useMemo(
    () =>
      typeof icon === "string"
        ? () => <Text fontSize={24}>{icon}</Text>
        : (icon ?? null),
    [icon],
  );

  return (
    <Box
      onPress={onSelect}
      cursor="pointer"
      hoverStyle={{
        backgroundColor: selected ? "#ffe48a" : "$backgroundMutedBlock",
      }}
      gap={"$small"}
      backgroundColor={selected ? "#ffeeb4" : "$backgroundBlock"}
      {...boxProps}
    >
      <XStack alignItems="center" gap={"$medium"}>
        <YStack gap="$small" flex={1}>
          <Icon />
          <XStack alignItems="center" gap="$small">
            {selected && <CheckCircle2 size={16} />}
            <Label>{title}</Label>
          </XStack>
          <Body>{description}</Body>
        </YStack>
        {showChevron && <ChevronRight size={24} flexShrink={0} />}
      </XStack>
    </Box>
  );
};
